module.exports = __webpack_public_path__ + "img/Bancontact.e639923e.svg";